// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T26v","noData":"styles_noData__2JNEl"};